// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { PaginationTokens } from './type';

const paginationTokens: PaginationTokens = {
  paginationFontSize: 'Font-14',
  paginationFontWeight: 'Weight-regular',
  paginationSmallFontSize: 'Font-12',
  paginationSmallFontWeight: 'Weight-regular',
  paginationLargeFontSize: 'Font-16',
  paginationLargeFontWeight: 'Weight-regular',
  paginationFontColor: 'Neutral-text-5',
  paginationNearlyMargin: 'Spacing-8',
};

export default paginationTokens;
